import React from 'react';
import { LazySection } from './LazySection';
export function Solucion() {
  return <LazySection id="sistema" className="bg-cream !pt-[80px] md:!pt-[100px] !pb-[60px] md:!pb-[70px]" data-id="element-346">
      <div className="container-wide" data-id="element-347">
        <div className="text-center mb-[50px]" data-id="element-348">
          <span className="inline-block bg-ink text-gold-light px-5 py-2 rounded-full text-xs font-semibold tracking-[0.15em] uppercase mb-6" data-id="element-349">
            🌳 El Origen de Tus Bloqueos
          </span>
          <h2 className="text-[clamp(34px,5.5vw,56px)] mb-4 leading-[1.05]" data-id="element-350">
            6 Módulos — del <span className="text-gold-dark" data-id="element-351">diagnóstico</span>{' '}
            a la{' '}
            <span className="text-gold-dark" data-id="element-352">
              <span className="highlight-keyword" data-id="element-353">liberación</span>
            </span>
          </h2>
          <p className="font-serif text-[clamp(18px,2.2vw,22px)] text-ink-soft font-normal max-w-[640px] mx-auto mb-9 italic leading-[1.4]" data-id="element-354">
            Un camino estructurado. No un kit de herramientas sueltas.
          </p>
        </div>

        {/* Spines */}
        <div className="grid grid-cols-3 md:grid-cols-6 gap-2.5 md:gap-3 max-w-[720px] mx-auto mb-[50px]" data-id="element-355">
          {[{
          num: '01',
          title: 'El Mapa',
          bg: 'from-[#5b7a9e] to-[#3f5b7d]'
        }, {
          num: '02',
          title: 'La Herencia',
          bg: 'from-[#8a6436] to-[#604622]'
        }, {
          num: '03',
          title: 'La Separación',
          bg: 'from-[#9c4a2a] to-[#6d3219]'
        }, {
          num: '04',
          title: 'La Liberación',
          bg: 'from-[#6b7a5a] to-[#4a5540]'
        }, {
          num: '05',
          title: 'La Integración',
          bg: 'from-[#b8894b] to-[#8a6436]'
        }, {
          num: '06',
          title: 'La Continuidad',
          bg: 'from-[#2a211a] to-[#1f1a14]'
        }].map((spine, i) => <div key={i} className={`aspect-[3/4] rounded-lg flex items-end justify-center p-3.5 md:px-2 text-white/95 text-[11px] font-semibold tracking-[0.05em] text-center shadow-[0_8px_20px_rgba(0,0,0,0.15)] relative transition-transform duration-300 hover:-translate-y-1.5 cursor-default bg-gradient-to-br ${spine.bg}`} data-id="element-356">
              <span className="absolute top-3 left-0 right-0 text-center font-serif text-[20px] font-medium text-white/40" data-id="element-357">
                {spine.num}
              </span>
              {spine.title}
            </div>)}
        </div>

        <p className="text-center font-serif text-ink text-[15px] font-medium tracking-[0.08em] mb-[50px] uppercase" data-id="element-358">
          — 6 módulos · sistema completo —
        </p>

        {/* Modulos List */}
        <div className="bg-white border border-border rounded-[20px] p-7 md:px-10 md:py-9 max-w-[820px] mx-auto mb-10" data-id="element-359">
          <h3 className="text-[14px] tracking-[0.2em] uppercase text-gold-dark mb-6 font-semibold font-sans" data-id="element-360">
            ✦ El proceso · del origen al corte ✦
          </h3>

          <div className="flex flex-col" data-id="element-361">
            {[{
            color: 'bg-[#5b7a9e]',
            num: 'Módulo 1 —',
            name: 'El Mapa · Genograma Familiar',
            desc: 'Trazás tu sistema en 3 generaciones. Por primera vez ves el <strong>patrón completo</strong>, no solo tu fragmento.'
          }, {
            color: 'bg-[#8a6436]',
            num: 'Módulo 2 —',
            name: 'La Herencia · Anamnesis Sistémica',
            desc: 'Identificás qué emociones y mandatos viajaron hasta vos. <strong>Desbloqueás información</strong> oculta en tu familia.'
          }, {
            color: 'bg-[#9c4a2a]',
            num: 'Módulo 3 —',
            name: 'La Separación · Lo Mío vs Lo Heredado',
            desc: 'El momento bisagra. Separás tus emociones de las que cargás por lealtad inconsciente. <strong>La primera liberación real.</strong>'
          }, {
            color: 'bg-[#6b7a5a]',
            num: 'Módulo 4 —',
            name: 'La Liberación · Cartas Terapéuticas',
            desc: 'Cartas que reordenan el sistema interno. Devolvés simbólicamente lo que no es tuyo — <strong>el acto que cierra el ciclo.</strong>'
          }, {
            color: 'bg-[#b8894b]',
            num: 'Módulo 5 —',
            name: 'La Integración · Diario de Transformación',
            desc: 'Prompts diarios para consolidar el cambio. Que el entendimiento <strong>se mueva al cuerpo y a tus decisiones.</strong>'
          }, {
            color: 'bg-[#2a211a]',
            num: 'Módulo 6 —',
            name: 'La Continuidad · Protocolos de Conflictos',
            desc: 'Protocolos específicos para cuando el sistema reaccione. Sabés exactamente <strong>qué hacer cuando el patrón quiera volver.</strong>'
          }].map((mod, i) => <div key={i} className="grid grid-cols-[20px_1fr] md:grid-cols-[40px_1fr] gap-3.5 py-4 border-b border-dashed border-ink/10 last:border-0 last:pb-1 items-start" data-id="element-362">
                <div className={`w-3 h-3 rounded-[3px] mt-[7px] ${mod.color}`} data-id="element-363" />
                <div className="flex flex-wrap items-baseline gap-x-2.5" data-id="element-364">
                  <span className="font-serif font-semibold text-[16px] text-ink" data-id="element-365">
                    {mod.num}
                  </span>
                  <span className="font-serif font-medium text-[17px] text-gold-dark" data-id="element-366">
                    {mod.name}
                  </span>
                  <p className="text-[15px] text-ink-soft leading-[1.5] w-full mt-1" dangerouslySetInnerHTML={{
                __html: mod.desc
              }} data-id="element-367" />
                </div>
              </div>)}
          </div>
        </div>

        {/* Incluye */}
        <div className="max-w-[820px] mx-auto mb-[60px] bg-ink text-cream rounded-[20px] p-7 md:px-10 md:py-9" data-id="element-368">
          <h3 className="text-gold-light text-center text-[18px] mb-6 font-medium font-serif" data-id="element-369">
            ✦ Cada módulo incluye ✦
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-y-2.5 gap-x-6" data-id="element-370">
            {['PDF imprimible con el proceso paso a paso', 'Plantillas editables para completar', 'Ejemplos resueltos para orientarte', 'Ejercicios guiados aplicables desde el día 1', 'Preguntas de integración al cierre', 'Protocolo de contención para lo que aparezca', 'Lenguaje cálido pero con base clínica', '100% digital · descargable · para siempre tuyo'].map((item, i) => <div key={i} className="flex items-start gap-2.5 text-[14px] leading-[1.5] text-cream/90 py-1.5" data-id="element-371">
                <span className="text-green-check font-semibold shrink-0" data-id="element-372">
                  ✓
                </span>
                {item}
              </div>)}
          </div>
        </div>
      </div>
    </LazySection>;
}